export default function Features() {
  const features = [
    {
      icon: 'ri-lock-line',
      title: 'Advanced Security',
      description: 'Industry-leading encryption protocols protect your data and privacy across all our applications with zero-log policies.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Optimized Performance',
      description: 'Lightning-fast connections and efficient resource management ensure smooth operation without draining battery life.'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Intuitive Design',
      description: 'Clean, user-friendly interfaces make complex features accessible to everyone, from beginners to power users.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Coverage',
      description: 'Access servers worldwide with automatic selection for optimal speed and reliability wherever you are.'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Support',
      description: 'Dedicated customer support team ready to assist you anytime with technical issues or questions.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regular Updates',
      description: 'Continuous improvements and new features delivered through frequent updates to enhance your experience.'
    }
  ];

  return (
    <section id="features" className="py-36 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-28">
          <div 
            className="inline-block px-4 py-2 rounded-md mb-8"
            style={{ backgroundColor: '#E6F4F4', color: '#0A4D4D' }}
          >
            <span className="text-xs uppercase tracking-wide font-medium">Key Features</span>
          </div>
          <h2 className="text-5xl font-normal mb-6" style={{ fontFamily: 'Playfair Display, serif', color: '#1A1A1A' }}>
            Why Choose Our Apps
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#6A6A6A' }}>
            Powerful features designed to deliver exceptional mobile experiences
          </p>
        </div>
        
        <div className="grid grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="rounded-2xl p-12 transition-all duration-300 group cursor-pointer"
              style={{ backgroundColor: '#FAFAFA' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#0A4D4D';
                const title = e.currentTarget.querySelector('.feature-title') as HTMLElement;
                const desc = e.currentTarget.querySelector('.feature-desc') as HTMLElement;
                const iconBg = e.currentTarget.querySelector('.icon-bg') as HTMLElement;
                const icon = e.currentTarget.querySelector('.icon') as HTMLElement;
                if (title) title.style.color = '#FFFFFF';
                if (desc) desc.style.color = '#E0E0E0';
                if (iconBg) iconBg.style.backgroundColor = '#FFFFFF';
                if (icon) icon.style.color = '#0A4D4D';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#FAFAFA';
                const title = e.currentTarget.querySelector('.feature-title') as HTMLElement;
                const desc = e.currentTarget.querySelector('.feature-desc') as HTMLElement;
                const iconBg = e.currentTarget.querySelector('.icon-bg') as HTMLElement;
                const icon = e.currentTarget.querySelector('.icon') as HTMLElement;
                if (title) title.style.color = '#2C2C2C';
                if (desc) desc.style.color = '#666666';
                if (iconBg) iconBg.style.backgroundColor = '#E6F4F4';
                if (icon) icon.style.color = '#0A4D4D';
              }}
            >
              <div 
                className="icon-bg w-12 h-12 rounded-full flex items-center justify-center mb-6 transition-colors duration-300"
                style={{ backgroundColor: '#E6F4F4' }}
              >
                <i className={`${feature.icon} icon text-xl transition-colors duration-300`} style={{ color: '#0A4D4D' }}></i>
              </div>
              <h3 className="feature-title text-2xl font-bold mb-4 transition-colors duration-300" style={{ color: '#2C2C2C' }}>
                {feature.title}
              </h3>
              <p className="feature-desc text-base leading-relaxed transition-colors duration-300" style={{ color: '#666666', lineHeight: '1.6' }}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}